import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"padding":"20px"},
  class: "batch-qualifications-audit"
}

import { reactive, ref, withDefaults } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseAlert,
  BaseFormRef,
  BaseRadioGroup,
  BaseRadio,
  BaseDialog,
  BaseButton
} from 'xrk-components';
import { auditQua } from '../data-source/apis';

// 声明 prop 属性

export default /*#__PURE__*/_defineComponent({
  __name: 'batch-qualifications-audit',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    projectId: { default: null },
    selectionRows: { default: null }
  },
  emits: ['confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const formData = reactive({
  auditOpinion: '',
  auditStatus: null
});
const formRef = ref<BaseFormRef>(null);
const onCancel = () => {
  props.remove();
};

const auditOptionRules = [
  {
    required: true,
    validator: (rule: any, value: any, callback: any) => {
      if (value === '') {
        return callback(new Error('请填写不通过原因，最少5个字'));
      } else if (value.length < 5) {
        return callback(new Error('请填写不通过原因，最少5个字'));
      } else {
        callback();
      }
    }
  }
];

const onConfirm = async () => {
  await formRef.value.validate();
  await auditQua({
    projectId: props.projectId,
    userId: props.selectionRows.map(item => item.userId),
    auditStatus: formData.auditStatus,
    auditOpinion: formData.auditOpinion,
    auditType: 1
  });
  props.remove();
  emits('confirm');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "批量审核资质",
    width: "470px"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseAlert), {
          title: `您正在对${_ctx.selectionRows.length}个终端服务者项目资质进行审核，请选择审核结果。`,
          type: "warning",
          closable: false
        }, null, 8, ["title"]),
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              rules: [{ required: true, message: '请选择审核状态' }],
              prop: "auditStatus",
              label: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadioGroup), {
                  style: {"width":"100%","height":"32px","margin":"20px 0"},
                  modelValue: formData.auditStatus,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.auditStatus) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseRadio), {
                      border: "",
                      value: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核通过")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(BaseRadio), {
                      border: "",
                      value: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核不通过")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (formData.auditStatus === 3)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  rules: auditOptionRules,
                  prop: "auditOpinion",
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      placeholder: "请填写审核不通过原因，最少5个字",
                      modelValue: formData.auditOpinion,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.auditOpinion) = $event)),
                      style: {"width":"100%"},
                      maxlength: 150,
                      "show-word-limit": true,
                      type: "textarea",
                      rows: 5
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})